onInteractive(function() {
	// The CMS writes a sizes attribute from a fixed screen fraction per image. Images that are a third
	// of the screen on desktop fill the whole width on a phone, and photos cropped with object-fit:
	// cover are shown larger than their box, so the browser would pick a variant that is too small and
	// the photo looks soft. Measuring the rendered box gives the width the browser really needs.
	function aspectOf(picture) {
		var source = picture.querySelector('source[srcset], img[srcset]');
		if (!source) {
			return null;
		}
		var width = source.getAttribute('srcset').match(/width=(\d+)/);
		var height = source.getAttribute('srcset').match(/height=(\d+)/);
		return width && height ? parseInt(width[1], 10) / parseInt(height[1], 10) : null;
	}

	function boxOf(picture, img) {
		var box = img.getBoundingClientRect();
		if (box.width && box.height) {
			return box;
		}
		// Hidden carousel slides have no box of their own; they get the size of the carousel. Images
		// without fixed dimensions have no width before they load; their column is the limit then.
		var element = picture.closest('.carousel') || picture.parentElement;
		while (element && !element.getBoundingClientRect().width) {
			element = element.parentElement;
		}
		return element ? element.getBoundingClientRect() : box;
	}

	// Views of the base template (news overview, related news, albums, logos) request the default
	// compression of 75, which leaves visible blocks around the lettering on the newspaper covers in
	// the news photos. Variants without an explicit quality are requested at 90 instead.
	var qualityPattern = /(dynamic\/image\/[0-9a-f]+\/)(?![^\s"]*quality=)/g;

	function raiseQuality(element) {
		['srcset', 'src'].forEach(function(attribute) {
			var value = element.getAttribute(attribute);
			if (value && value.indexOf('dynamic/image/') !== -1) {
				var raised = value.replace(qualityPattern, '$1quality=90/');
				if (raised !== value) {
					element.setAttribute(attribute, raised);
				}
			}
		});
	}

	function updatePicture(picture) {
		var img = picture.querySelector('img');
		if (!img) {
			return;
		}
		picture.querySelectorAll('source, img').forEach(raiseQuality);
		var box = boxOf(picture, img);
		if (!box.width) {
			return;
		}
		var needed = Math.min(box.width, img.getBoundingClientRect().width || box.width);
		var aspect = aspectOf(picture);
		if (aspect && box.height && getComputedStyle(img).objectFit === 'cover') {
			needed = Math.max(box.width, box.height * aspect);
		}
		picture.querySelectorAll('source, img').forEach(function(element) {
			element.setAttribute('sizes', Math.ceil(needed) + 'px');
		});
	}

	function updateSizes() {
		document.querySelectorAll('#page main picture').forEach(updatePicture);
	}

	// The aside of a content page travels along with the text, but only when it fits on the screen;
	// a taller aside would hide its own bottom until the end of the page.
	function updateAside() {
		document.querySelectorAll('.page-aside').forEach(function(aside) {
			aside.classList.remove('is-sticky');
			var header = document.querySelector('.nav-header');
			var offset = (header ? header.getBoundingClientRect().height : 0) + 48;
			if (aside.offsetHeight + offset < window.innerHeight) {
				aside.classList.add('is-sticky');
			}
		});
	}

	updateSizes();
	updateAside();
	window.addEventListener('load', updateAside);
	var resizeTimer = null;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			updateSizes();
			updateAside();
		}, 200);
	});

	// The news overview loads more items while scrolling and the editor re-renders partials; new
	// pictures get the same treatment as the ones that were there on page load.
	var main = document.querySelector('#page main');
	if (main && window.MutationObserver) {
		new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				mutation.addedNodes.forEach(function(node) {
					if (node.nodeType !== 1) {
						return;
					}
					if (node.matches('picture')) {
						updatePicture(node);
					}
					node.querySelectorAll('picture').forEach(updatePicture);
				});
			});
		}).observe(main, {childList: true, subtree: true});
	}
});
